

import { ResourceItemHtmlProviderWug } from "./site-spicific-data/resource-item-html-provider-wug.js";
import { ResourceItemHtmlProviderIpswitch } from "./site-spicific-data/resource-item-html-provider-ipswitch.js";
import { ResourceItemHtmlProviderChefPartners } from "./site-spicific-data/resource-item-html-provider-chef-partners.js";
import { ResourceItemHtmlProviderChefCustomers } from "./site-spicific-data/resource-item-html-provider-chef-customers.js";
import { ResourceItemHtmlProviderChefResources } from "./site-spicific-data/resource-item-html-provider-chef-resources.js";
import { ResourceItemHtmlProviderChefEvents } from "./site-spicific-data/resource-item-html-provider-chef-events.js";
import { ResourceItemHtmlProviderChefWebinars } from "./site-spicific-data/resource-item-html-provider-chef-webinars.js";
import { ResourceItemHtmlProviderProgressDciOverview } from "./site-spicific-data/resource-item-html-provider-progress-dci-overview.js";
import { ResourceItemHtmlProviderProgressDciAccordion } from "./site-spicific-data/resource-item-html-provider-progress-dci-accordion.js";
import { ResourceItemHtmlProviderProgressDciList } from "./site-spicific-data/resource-center-html-provider-progress-dci-connectors-list.js";
import { ResourceItemHtmlProviderProgressUserAwardsList } from "./site-spicific-data/resource-center-html-provider-progress-user-awards-list.js";
import { ResourceItemHtmlProviderKempPartners} from "./site-spicific-data/resource-item-html-provider-kemp-partners.js";
import { ResourceItemHtmlProviderFlowmonPartners} from "./site-spicific-data/resource-item-html-provider-flowmon-partners.js";
import { ResourceItemHtmlProviderKempVideos} from "./site-spicific-data/resource-item-html-provider-kemp-videos.js";
import { ResourceItemHtmlProviderFlowmonResources } from "./site-spicific-data/resource-item-html-provider-flowmon-resources.js";
import { ResourceItemHtmlProviderKempResources } from "./site-spicific-data/resource-item-html-provider-kemp-resources.js";
import{ ResourceItemHtmlProviderFlowmonResearchAndProjects } from "./site-spicific-data/resource-item-html-provider-flowmon-research-projects.js";
import{ ResourceItemHtmlProviderChefInIpswitchResources } from "./site-spicific-data/resource-item-html-provider-chef-in-ipswitch-resources.js";
import{ ResourceItemHtmlProviderProgress } from "./site-spicific-data/resource-item-html-provider-progress.js";
import{ ResourceItemHtmlProviderProgressWebinars } from "./site-spicific-data/resource-item-html-provider-progress-webinars.js";
import{ ResourceItemHtmlProviderTelerikReleaseNotes } from "./site-spicific-data/resource-item-html-provider-progress-telerik-release-notes.js";
import{ ResourceItemHtmlProviderProgressTutorials } from "./site-spicific-data/resource-item-html-provider-progress-tutorials.js";
import { ResourceItemHtmlProviderProgressSitefinityIntegrations } from "./site-spicific-data/resource-item-html-provider-progress-sitefinity-integrations.js";



export class ResourceCenterObjectFactory {
  constructor(settings) {
    this.factorySettings = settings;
    this.providers = {
      Ipswitch: ResourceItemHtmlProviderIpswitch,
      ChefPartners: ResourceItemHtmlProviderChefPartners,
      ChefCustomers: ResourceItemHtmlProviderChefCustomers,
      ChefEvents: ResourceItemHtmlProviderChefEvents,
      ChefWebinars: ResourceItemHtmlProviderChefWebinars,
      ChefResources: ResourceItemHtmlProviderChefResources,
      ChefInIpswitchResources: ResourceItemHtmlProviderChefInIpswitchResources,
      WUG: ResourceItemHtmlProviderWug,
      ProgressDciOverview: ResourceItemHtmlProviderProgressDciOverview,
      ProgressDciAccordion: ResourceItemHtmlProviderProgressDciAccordion,
      ProgressDciConnectorsList: ResourceItemHtmlProviderProgressDciList,
      ProgressUserAwardsList: ResourceItemHtmlProviderProgressUserAwardsList,
      ProgressSitefinityIntegrations: ResourceItemHtmlProviderProgressSitefinityIntegrations,
      KempPartners: ResourceItemHtmlProviderKempPartners,
      Kemp: ResourceItemHtmlProviderKempResources,
      FlowmonPartners: ResourceItemHtmlProviderFlowmonPartners,
      KempVideos: ResourceItemHtmlProviderKempVideos,
      FlowmonResearchAndProjects: ResourceItemHtmlProviderFlowmonResearchAndProjects,
      Flowmon: ResourceItemHtmlProviderFlowmonResources,
      Progress: ResourceItemHtmlProviderProgress,
      ProgressTutorials: ResourceItemHtmlProviderProgressTutorials,
      ProgressWebinars: ResourceItemHtmlProviderProgressWebinars,
      TelerikReleaseNotes: ResourceItemHtmlProviderTelerikReleaseNotes,
      default: ResourceItemHtmlProviderIpswitch
    }
  }

  getResourceItemHtmlProvider(filterService) {
    debugger;    
    if (this.factorySettings.ResourceItemHtmlProviderName) {
      let prov = this.providers[this.factorySettings.ResourceItemHtmlProviderName];
      return new prov(filterService);
    }
    else {
      let prov = this.providers.default;
      return new prov(filterService);
    }
  }
}
